import * as Yup from 'yup'

export interface IUserAdminSchema {
    name: string
    email: string
}

const userManagementSchema: Yup.SchemaOf<IUserAdminSchema> = Yup.object()
    .shape({
        name: Yup.string().required('Nome é de usuário obrigatório').max(50, 'Máx 50 caracteres'),
        email: Yup.string().required('E-mail é obrigatório').email('E-mail inválido').max(100, 'Máx 100 caracteres'),
    })
    .required()

export default userManagementSchema
